<template>
  <div class="tournament-laurel-wrap">
    <div class="tournament-laurel" :class="`tournament-laurel-${state}`">
      <div class="tournament-laurel-text" v-html="text"></div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { marked } from 'marked'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

const props = defineProps<{
  prevBestScore?: number
  score: number
  rank: number
  state: TOURNAMENT_LAUREL_STATE // || FINISHED || HISTORY;
}>()
const { t } = useI18n()

const text = computed(() => {
  const bestScorePartial =
    props.prevBestScore !== null
      ? ` ${t('tViews.joined.text_tournamentInfo_bestScorePartial', { prevBestScore: props.prevBestScore })}, `
      : ''
  const text = t('tViews.joined.text_tournamentInfo_' + props.state, {
    score: props.score,
    bestScorePartial: bestScorePartial,
    rank: props.rank,
  })
  return marked(text)
})
</script>

<script lang="ts">
export enum TOURNAMENT_LAUREL_STATE {
  HISTORY = 'history',
  FINISHED = 'finished',
  RUNNING = 'running',
}
</script>

<style lang="less">
@import '~@npm/@gd/common-styles/dist/color-vars';
.tournament-laurel-wrap {
  display: flex;
  justify-content: center;
}
.tournament-laurel {
  color: @c1-a;
  display: flex;
  &-finished,
  &-history {
    &::before,
    &::after {
      align-self: flex-end;
      background: url('../assets/laurel.png') no-repeat center center;
      background-size: contain;
      content: ' ';
      width: 4em;
      height: 100%;
      position: relative;
      display: block;
    }
    &:after {
      transform: scaleX(-1);
    }
  }
  h2 {
    margin-top: 0.413em;
    margin-bottom: 0.3em;
  }
  p {
    font-size: 1.25em;
    line-height: 1.25em;
    margin-top: 0;
    margin-bottom: 0.6em;
    font-weight: bold;
  }
  &-text {
    margin: 0 0.5em;
  }
}
</style>
